module.exports = __webpack_public_path__ + "img/Layer 16.a71c67ad.svg";